<h1 mat-dialog-title>Selected Payers</h1>
<div mat-dialog-content>
    <table mat-table [dataSource]="data" >
        
        <!-- Epic/Legacy Payer Column-->
        <ng-container matColumnDef="carrierName">
            <th mat-header-cell *matHeaderCellDef>Epic/Legacy Payer</th>
            <td mat-cell *matCellDef="let row"> {{ row.carrierName }} </td>
        </ng-container>

        <!-- Experian Payer Column-->
        <ng-container matColumnDef="payerName">
            <th mat-header-cell *matHeaderCellDef>Experian Payer</th>
            <td mat-cell *matCellDef="let row"> {{ row.payerName }} </td>  
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
<div mat-dialog-actions class="button-group">
    <button mat-raised-button color="warn" (click)="deleteButtonClicked()">Delete</button>
    <button mat-raised-button mat-dialog-close>Cancel</button>
</div>